<template>
  <div class="tab-content">

    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- selling -->
      <el-tab-pane :disabled="!engagementPermission.viewCRMSelling" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_crm_selling')" name="sellingProject">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createCRMSellingEstimate" :label="$t('e_tab_crm_selling_estimate')" name="estimateProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMSellingQuotation" :label="$t('e_tab_crm_selling_quotation')" name="quotationProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMSellingSalesOrder" :label="$t('e_tab_crm_selling_salesOrder')" name="salesOrderProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMSellingSalesPosting" :label="$t('e_tab_crm_selling_salesPosting')" name="salesPostingProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskCRMSelling" v-else :label="$t('e_tab_crm_selling')" name="sellingTask">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createTaskCRMSellingEstimate" :label="$t('e_tab_crm_selling_estimate')" name="estimateTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMSellingQuotation" :label="$t('e_tab_crm_selling_quotation')" name="quotationTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMSellingSalesOrder" :label="$t('e_tab_crm_selling_salesOrder')" name="salesOrderTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMSellingSalesPosting" :label="$t('e_tab_crm_selling_salesPosting')" name="salesPostingTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- delivering -->
      <el-tab-pane :disabled="!engagementPermission.viewCRMDelivering" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_crm_delivering')" name="deliveringProject">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createCRMDeliveringDeliveryOrder" :label="$t('e_tab_crm_delivering_deliveryOrder')" name="deliveryOrderProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMDeliveringPackingList" :label="$t('e_tab_crm_delivering_packingList')" name="packingListProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMDeliveringDeliveryReciept" :label="$t('e_tab_crm_delivering_deliveryReciept')" name="deliveryRecieptProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskCRMDelivering" v-else :label="$t('e_tab_crm_delivering')" name="deliveringTask">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createTaskCRMDeliveringDeliveryOrder" :label="$t('e_tab_crm_delivering_deliveryOrder')" name="deliveryOrderTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMDeliveringPackingList" :label="$t('e_tab_crm_delivering_packingList')" name="packingListTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMDeliveringDeliveryReciept" :label="$t('e_tab_crm_delivering_deliveryReciept')" name="deliveryRecieptTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- managing -->
      <el-tab-pane :disabled="!engagementPermission.viewCRMManaging" v-if="selectedRow.type === 'Engagement'" :label="$t('e_tab_crm_managing')" name="managingProject">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createCRMManagingSalesInvoice" :label="$t('e_tab_crm_managing_salesInvoice')" name="salesInvoiceProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMManagingClientPayment" :label="$t('e_tab_crm_managing_clientPayment')" name="clientPaymentProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMManagingClientReturns" :label="$t('e_tab_crm_managing_clientReturns')" name="clientReturnsProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMManagingReminders" :label="$t('e_tab_crm_managing_reminders')" name="remindersProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMManagingFinanceCharges" :label="$t('e_tab_crm_managing_financeCharges')" name="financeChargesProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createCRMManagingSalesCredits" :label="$t('e_tab_crm_managing_salesCredits')" name="salesCreditsProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>
      <el-tab-pane :disabled="!engagementPermission.viewTaskCRMManaging" v-else :label="$t('e_tab_crm_managing')" name="managingTask">

          <el-tabs>
            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingSalesInvoice" :label="$t('e_tab_crm_managing_salesInvoice')" name="salesInvoiceTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingClientPayment" :label="$t('e_tab_crm_managing_clientPayment')" name="clientPaymentTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingClientReturns" :label="$t('e_tab_crm_managing_clientReturns')" name="clientReturnsTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingReminders" :label="$t('e_tab_crm_managing_reminders')" name="remindersTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingFinanceCharges" :label="$t('e_tab_crm_managing_financeCharges')" name="financeChargesTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!engagementPermission.createTaskCRMManagingSalesCredits" :label="$t('e_tab_crm_managing_salesCredits')" name="salesCreditsTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- estimate -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Estimate" name="estimateProject">
          Current Service Under Development
          (Estimate project)
      </el-tab-pane>
      <el-tab-pane v-else label="Estimate" name="estimateTask">
          Current Service Under Development
          (Estimate)
      </el-tab-pane> -->

      <!-- quotation -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Quotation" name="quotationProject">
          Current Service Under Development
          (Quotation project)
      </el-tab-pane>
      <el-tab-pane v-else label="Quotation" name="quotationTask">
          Current Service Under Development
          (Quotation)
      </el-tab-pane> -->

      <!-- sales order -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Sales Order" name="salesOrderProject">
          Current Service Under Development
          (Sales Order project)
      </el-tab-pane>
      <el-tab-pane v-else label="Sales Order" name="salesOrderTask">
          Current Service Under Development
          (Sales Order)
      </el-tab-pane> -->

      <!-- invoice -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Invoice" name="invoiceProject">
          Current Service Under Development
          (Invoice project)
      </el-tab-pane>
      <el-tab-pane v-else label="Invoice" name="invoiceTask">
          Current Service Under Development
          (Invoice)
      </el-tab-pane> -->

    </el-tabs>

    <!-- bookmark -->
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div v-if="selectedRow.type === 'Engagement'">-->
<!--        <div v-if="bookmarkListEngagement.crm" @click="changeBookMarkEngagement(bookmarkListEngagement.crm, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMarkEngagement(bookmarkListEngagement.crm, $route.query.companyId, selectedRow.engagementId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <div v-if="bookmarkList.crm" @click="changeBookMark(bookmarkList.crm, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.crm, $route.query.companyId, selectedRow.engagementId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  export default {
    components: {

    },
    props: [
      'isEngagement',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListEngagement',
      'engagementPermission'
    ],
    data() {
      return {
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // estimate
        if(tab.label === "Estimate" && tab.name == "estimateProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Estimate" && tab.name == "estimateTask" && !this.isEngagement){
          // dispatch
        }

        // quotation
        if(tab.label === "Quotation" && tab.name == "quotationProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Quotation" && tab.name == "quotationTask" && !this.isEngagement){
          // dispatch
        }

        // sales order
        if(tab.label === "Sales Order" && tab.name == "salesOrderProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Sales Order" && tab.name == "salesOrderTask" && !this.isEngagement){
          // dispatch
        }

        // invoice
        if(tab.label === "Invoice" && tab.name == "invoiceProject" && this.isEngagement){
          // dispatch
        }
        if(tab.label === "Invoice" && tab.name == "invoiceTask" && !this.isEngagement){
          // dispatch
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, engagementId, taskId){
        let data = this.bookmarkList
        data.crm = !this.bookmarkList.crm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${engagementId}&engagementTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.crm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      changeBookMarkEngagement(state, companyId, engagementId, taskId){
        let data = this.bookmarkListEngagement
        data.crm = !this.bookmarkListEngagement.crm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setEngagement?companyId=${companyId}&engagementId=${engagementId}`, data)
          .then(response => {
            if (this.bookmarkListEngagement.crm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
